import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { upSubStatusDataItem, SubStatusDataItem, StatusDataItem } from '../../services/interfaces';
import { deleteSubStatus, saveSubStatus } from '../../services/apiAdminService';
import { getStatusList, getSubStatusList } from '../../services/apiService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { StatusList } from '../FormComponents';

interface PageState {
    skip: number;
    take: number;
}

//const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'groupName', dir: 'asc' },{ field: 'pubName', dir: 'asc' }],
    filter: undefined,
    skip:0,
    take:20
};

interface editProps{
    status:SubStatusDataItem,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewSubStatus
{
    status:string
    stat2Field:string
    fieldString:string
    operationID:number        
}


const EditDialog=(props:editProps)=>{

    const [newStatus, setNewStatus]= useState<NewSubStatus>(
        {
            status:"",
            stat2Field:"",
            fieldString:"",
            operationID:0      
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedStatus,setSelectedStatus]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");

    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    
    const setStatusName=(e: StatusDataItem)=>{
        console.log(e);
        setNewStatus({...newStatus, status: (e.status) || ''})        
    }

    const setStat2Field=(e: InputChangeEvent)=>{
        setNewStatus({...newStatus, stat2Field: (e.value)})
    }

    const setFieldString=(e: InputChangeEvent)=>{
        setNewStatus({...newStatus, fieldString: (e.value)})
    }

    const setOperationId=(e:InputChangeEvent)=>{
        setNewStatus({...newStatus, operationID: Number(e.value)})
    }


    const validateStatus= async()=>{
        var statusValid={
            status:false,
            statField:false,
            subStatus:true
        }
        if (newStatus.status!=""){
            statusValid.status=true;
        }
        if (newStatus.stat2Field!==""){
            statusValid.statField=true;            
        }
        if (newStatus.fieldString!==""){
            statusValid.subStatus=true;            
        }
        return statusValid;
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const deleteThisSubStatus=()=>{
        if (props.action=="Edit"){
            const status = newStatus.status;
            const fieldString = newStatus.fieldString;
            const stat2Field = newStatus.stat2Field;
            if (status!=""){
               deleteSubStatus(status, stat2Field,fieldString);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisSubStatus= async ()=>{

        var oStatus;
        var oStat2Field:string;
        var oFieldString;
        console.log(newStatus);
        validateStatus().then((statValid)=>{
             if (statValid.status===true && statValid.statField===true && statValid.subStatus===true){
                 if (intAction==="Edit"){
                    //edit existing pub
                    oStatus=props.status.status;
                    oStat2Field = props.status.stat2Field;
                    oFieldString=props.status.fieldString
                 }else{
                     //create new pub
                    oStatus="";
                    oStat2Field = "";
                    oFieldString="";
                 }
                 var formData:upSubStatusDataItem = {
                    oStatus: oStatus,
                    oStat2Field: oStat2Field,
                    oFieldString: oFieldString,
                    Status: newStatus.status,
                    Stat2Field: newStatus.stat2Field,
                    FieldString: newStatus.fieldString,
                    OperationID: 0      
                };
                 console.log(formData);
                 saveSubStatus(formData).then((data)=>{
                     console.log(data);
                     props.onClose();
                 });    
             }else{
                 console.log("Missing fields");
             }    
        });
        
    }
    
    useEffect(()=>{
        console.log(props.status);
        console.log(newStatus);
    },[newStatus])

    useEffect(() => {  
        setDlgTitle(props.title);
        console.log(props.status); 
        if (props.status){
            setNewStatus({
                status: props.status.status,
                stat2Field: props.status.stat2Field,
                fieldString: props.status.fieldString,
                operationID: 0      
            });            
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"40vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Sub-status Entry' message='This will permanently delete the selected sub-status entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisSubStatus}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Status:</Label></Col>
                <Col xs="9"><StatusList value={[newStatus.status]} setStatus={setStatusName} type='Single' enabled={true} limited={false}></StatusList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Field:</Label></Col>
                <Col xs="9"><Input value={newStatus.stat2Field} onChange={setStat2Field} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Sub-Status:</Label></Col>
                <Col xs="9"><Input value={newStatus.fieldString} onChange={setFieldString}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Operation ID:</Label></Col>
                <Col xs="9"><Input value={newStatus.operationID} onChange={setOperationId}></Input></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisSubStatus}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminSubStatus (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [statuses, setStatuses] = useState([]);
    const [statusSelected, setStatusSelected]=useState<SubStatusDataItem>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(statuses,dataState));
    //const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');

    const setSelectedSubStat=(status:SubStatusDataItem)=>{
        setStatusSelected(status);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getStatuses();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Sub Status");
        setStatusSelected( {
            status:"",
            stat2Field:"",
            fieldString:"",
            operationID:0      
        })
        setShowEditDialog(true);
    }



    const getStatuses=()=>{
        getSubStatusList().then(data=>{
            setStatuses(data);
            //setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(statuses, e.dataState));
    };

    const processedData=process(statuses,dataState);
    // const pageChange = (event: GridPageChangeEvent) => {
    //     const targetEvent = event.targetEvent as PagerTargetEvent;        
    //     setPage({
    //         ...event.page,
    //         take:20
    //     });
    // }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const status:SubStatusDataItem=event.startDataItem;
        setSelectedSubStat(status);
        setAction("Edit");
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "status"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        console.log(statusSelected);
        if (statusSelected){
            setTitle("Status Configuration for: " + statusSelected?.status + " / " + statusSelected.fieldString);
            setShowEditDialog(true);
        }
    },[statusSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            getStatuses();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Sub Status Management</h2>
            <Toolbar>
                <Button title="New Sub-Status" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Status
                </Button>       
            </Toolbar>
            <Grid
                data={processedData}
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='uid'
                id="substatusGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                // onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                // skip={page.skip}
                // take={page.take}
                // total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='status' title='Status' width={200} />
                <GridColumn field='stat2Field' title='Field'/>
                <GridColumn field='fieldString' title='Sub Status'/>
                <GridColumn field='operationID' title='Operation IS'/>
            </Grid>
            {showEditDialog?
                <EditDialog title={title} status={statusSelected as SubStatusDataItem} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}